import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute, { GuestRoute } from './routes/ProtectedRoute';
import LoginPage from './LoginPage/LoginPage';
import Workers from './Sanay3yaView/DashboardView';
import FactoryManagerView from './ModeerView/FactoryManagerDashboard';
import SalesView from './SalesView/SalesDashboardView';
import SalesManagerView from './SalesManagerView/SalesManagerDashboardView';
import CompanyManagerView from './CompanyManagerView/CompanyManagerDashboardView';
import AccountingDashboardView from './AccountingView/AccountingDashboardView';
import ProductPriceList from './AccountingView/ProductPriceList';
import ProductManagement from './ProductManagement/ProductManagement';
import ProductsInventory from './ProductsInventory/ProductInventoryView';
import RequestsManagement from './Requests/RequestsManagement';
import CreateNewProduct from './CreateProduct/CreateNewProduct';
import EditProduct from './EditProduct/EditProduct';
import CreateNewUser from './CreateNewUser/CreateNewUser';
import ManageUsers from './ManageUsers/ManageUsers';
import SalesRequestsManagement from './SalesRequestsManagement/SalesRequestsManagement';
import SalesCreateRequest from './SalesCreateRequest/SalesCreateRequest';
import SalesMyRequests from './SalesMyRequests/SalesMyRequests';
import HeldOrdersPage from './HeldOrdersPage/HeldOrdersPage';
import Customers from './Customers/Customers';
import CustomerProfile from './CustomerProfile/CustomerProfile';
import AddCustomer from './AddCustomer/AddCustomer';
import LogsPage from './LogsPage/LogsPage';
import TaxSettingsPage from './Settings/TaxSettingsPage';
import DealsRegister from './AccountingView/DealsRegister';
import SalesReportsView from './SalesReports/SalesReportsView';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Main entry point */}
        <Route
          path="/"
          element={
            <GuestRoute>
              <LoginPage />
            </GuestRoute>
          }
        />

        {/* Worker View */}
        <Route
          path="/worker"
          element={
            <ProtectedRoute allowedRoles={['worker']}>
              <Workers />
            </ProtectedRoute>
          }
        />

        {/* Factory Manager View */}
        <Route
          path="/factory-manager"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <FactoryManagerView />
            </ProtectedRoute>
          }
        />

        {/* Sales View */}
        <Route
          path="/sales"
          element={
            <ProtectedRoute allowedRoles={['sales']}>
              <SalesView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-manager"
          element={
            <ProtectedRoute allowedRoles={['sales-manager']}>
              <SalesManagerView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounting"
          element={
            <ProtectedRoute allowedRoles={['accounting', 'admin']}>
              <AccountingDashboardView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounting/product-prices"
          element={
            <ProtectedRoute allowedRoles={['accounting', 'manager', 'admin']}>
              <ProductPriceList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounting/deals"
          element={
            <ProtectedRoute allowedRoles={['accounting', 'admin', 'manager', 'sales-manager']}>
              <DealsRegister />
            </ProtectedRoute>
          }
        />

        {/* Company Manager View */}
        <Route
          path="/company-manager"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CompanyManagerView />
            </ProtectedRoute>
          }
        />

        {/* Additional routes if needed */}
        <Route
          path="/product-management"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin', 'worker']}>
              <ProductManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products-inventory"
          element={
            <ProtectedRoute>
              <ProductsInventory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/requests-management"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <RequestsManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-new-product"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <CreateNewProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-products"
          element={
            <ProtectedRoute>
              <ProductsInventory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-product"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <EditProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-new-user"
          element={
            <ProtectedRoute allowedRoles={['admin', 'manager', 'sales-manager']}>
              <CreateNewUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-users"
          element={
            <ProtectedRoute allowedRoles={['admin', 'manager', 'sales-manager']}>
              <ManageUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="sales-requests-management"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin', 'sales-manager']}>
              <SalesRequestsManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-create-request"
          element={
            <ProtectedRoute allowedRoles={['sales', 'sales-manager']}>
              <SalesCreateRequest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-my-requests"
          element={
            <ProtectedRoute allowedRoles={['sales']}>
              <SalesMyRequests />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-reports"
          element={
            <ProtectedRoute allowedRoles={['sales']}>
              <SalesReportsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/held-orders"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <HeldOrdersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin', 'sales-manager', 'sales']}>
              <Customers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/:id"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin', 'sales-manager', 'sales']}>
              <CustomerProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/new"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin', 'sales-manager', 'sales']}>
              <AddCustomer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/logs"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <LogsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/tax"
          element={
            <ProtectedRoute allowedRoles={['manager', 'admin']}>
              <TaxSettingsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </Router>
  );
};

export default App;
